import React, { useEffect } from "react";
import {
  View,
  TouchableOpacity,
  StyleSheet,
  Image,
  Linking,
  BackHandler,
  Platform} from "react-native";
import { fonts } from "../styles/theme";
import AppText from "./AppText";

interface Props {
  storeUrl?: string;
}

/**
 * Full-screen, non-dismissible blocking screen shown when the installed
 * app version is older than the live store version. The app navigation
 * tree is not rendered while this is on screen, so the user cannot
 * continue using the app until they update.
 */
const ForceUpdateScreen: React.FC<Props> = ({ storeUrl }) => {
  // Swallow the Android hardware back button so it can't bypass the gate.
  useEffect(() => {
    if (Platform.OS !== "android") return;
    const sub = BackHandler.addEventListener("hardwareBackPress", () => true);
    return () => sub.remove();
  }, []);

  const handleUpdate = () => {
    if (storeUrl && storeUrl.startsWith("http")) {
      Linking.openURL(storeUrl).catch((err) =>
        console.error("Failed to open store URL:", err),
      );
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Image
          source={require("../../assets/android-splash.png")}
          style={styles.logo}
          resizeMode="contain"
        />
        <AppText style={styles.title}>Update Required</AppText>
        <AppText style={styles.message}>
          A new version of the app is available. Please update to the latest
          version to continue.
        </AppText>
      </View>

      <TouchableOpacity
        style={styles.button}
        onPress={handleUpdate}
        activeOpacity={0.85}
      >
        <AppText style={styles.buttonText}>Update Now</AppText>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
    paddingHorizontal: 28},
  content: {
    alignItems: "center"},
  logo: {
    width: 140,
    height: 140,
    marginBottom: 28},
  title: {
    fontFamily: fonts.regular,
    fontSize: 24,
    color: "#1A1A1A",
    textAlign: "center",
    marginBottom: 12},
  message: {
    fontFamily: fonts.regular,
    fontSize: 15,
    lineHeight: 24,
    color: "#6B7280",
    textAlign: "center",
    maxWidth: 320},
  button: {
    backgroundColor: "#3629B7",
    borderRadius: 14,
    paddingVertical: 16,
    marginTop: 36,
    alignItems: "center",
    justifyContent: "center"},
  buttonText: {
    fontFamily: fonts.medium,
    fontSize: 16,
    color: "#FFFFFF",
    letterSpacing: 0.3}});

export default ForceUpdateScreen;
